import React from 'react';

import { Box, LinearProgress, Paper, Typography } from '@mui/material';

interface JobProgressProps {
  jobId: string | null;
  jobStatus: string;
  progress: number;
}

/**
 * Displays job progress with a progress bar.
 * Shows job ID, humanized status, and percentage complete.
 */
export default function JobProgress({ jobId, jobStatus, progress }: JobProgressProps) {
  if (!jobId) {
    return null;
  }

  // Humanize job status for display
  const displayStatus =
    {
      waiting: 'Waiting',
      active: 'Processing',
      completed: 'Completed',
      failed: 'Failed',
      delayed: 'Delayed',
    }[jobStatus] || jobStatus;

  return (
    <Box mb={3}>
      <Paper sx={{ p: 2 }}>
        <Typography variant="subtitle2" gutterBottom>
          Job ID: <code>{jobId}</code>
        </Typography>
        <Typography variant="subtitle2" gutterBottom>
          Status: {displayStatus}
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Box sx={{ width: '100%', mr: 1 }}>
            <LinearProgress variant="determinate" value={progress} />
          </Box>
          <Box sx={{ minWidth: 50 }}>
            <Typography variant="body2" color="text.secondary">
              {Math.round(progress)}%
            </Typography>
          </Box>
        </Box>
      </Paper>
    </Box>
  );
}
